import { render } from "./NoSidebar.vue?vue&type=template&id=00d7c970"
import script from "./NoSidebar.vue?vue&type=script&lang=js"
export * from "./NoSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__